var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7799 6.26278C15.6775 5.94056 15.3966 5.7117 15.0643 5.68122L10.5498 5.26417L8.76472 1.0132C8.63309 0.701664 8.33333 0.5 8.00026 0.5C7.6672 0.5 7.36743 0.701664 7.23581 1.01393L5.45069 5.26417L0.935549 5.68122C0.6038 5.71242 0.323603 5.94056 0.220617 6.26278C0.117632 6.58501 0.212741 6.93843 0.463701 7.16122L3.87607 10.206L2.86984 14.7155C2.79621 15.0471 2.92271 15.3899 3.19312 15.5887C3.33847 15.6956 3.50852 15.75 3.68 15.75C3.82786 15.75 3.97452 15.7094 4.10614 15.6293L8.00026 13.2614L11.893 15.6293C12.1778 15.8036 12.5369 15.7877 12.8067 15.5887C13.0772 15.3893 13.2036 15.0464 13.13 14.7155L12.1237 10.206L15.5361 7.16183C15.7871 6.93843 15.8829 6.58561 15.7799 6.26278Z",
    fill: "#FFD15A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9a3ee3f6c50af44c956098ed17b0aa71.svg";
export { ForwardRef as ReactComponent };